/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconVulnerabilityOutline = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-vulnerability-outline',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M12.263 9.504v4m0 4h.01M10.88 4.396 2.654 18.602c-.456.788-.684 1.183-.65 1.506a1 1 0 0 0 .406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 0 0 .407-.705c.033-.323-.195-.718-.651-1.506L13.648 4.396c-.454-.785-.682-1.178-.978-1.31a1 1 0 0 0-.813 0c-.296.132-.524.525-.978 1.31Z", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
});
IconVulnerabilityOutline.displayName = 'IconVulnerabilityOutline';
export default IconVulnerabilityOutline;
